/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { themeV2, pxToEm, replacePXinStringWithEM, convertHexToRGB } from '@insticator/insticator-ui';
import { hoverTransition } from '../../utils/styles/general';



/* ++++++++++ --------------- CHARTCARDS : STYLES --------------- ++++++++++ */
export default {
    cardwrapper: {
        position: 'relative',
        boxShadow: replacePXinStringWithEM(`0px 0px 24px 0px ${convertHexToRGB(themeV2.color.base.boxShadow, 20)}`),
        display: 'flex',
        minHeight: pxToEm(56),
        extend: hoverTransition(),
        '& > .tooltip': {
            marginLeft: 'auto',
            position: 'absolute',
            top: pxToEm(24),
            right: pxToEm(24),
            '& .icon': {
                width: pxToEm(20),
                height: pxToEm(20),
                color: themeV2.color.base.gray.dark
            }
        },
        '&.isActive': {
            '&-true': {
                boxShadow: replacePXinStringWithEM(`inset 4px 0px 0px 0px ${themeV2.color.primary.main}`),
                cursor: 'default'
            },
            '&-false': {
                '&:hover': {
                    boxShadow: replacePXinStringWithEM(`0px 0px 24px 0px ${convertHexToRGB(themeV2.color.base.boxShadow, 50)}`)
                }
            }
        }
    },
    tooltipStyles: {
        '& .tip-content': {
            textAlign: 'left',
            maxHeight: pxToEm(230),
            overflow: 'auto',
            '& .tip': {
                '&-desc': {
                    '& h5': {
                        fontSize: pxToEm(15),
                        marginBottom: pxToEm(5)
                    },
                    '& ul': {
                        paddingLeft: pxToEm(30)
                    }
                }
            }
        }
    }
};
